import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { OrganizationSettingsDao } from '@app/dao/organization-settings/organization-settings.dao';
import { UserDao } from '@app/dao/user/user.dao';
import { Product, ProductsService } from '@app/providers/products.service';
import * as _ from 'lodash';
import { Observable, Subject, map, takeWhile } from 'rxjs';

@Component({
  selector: 'ea-product-sheet',
  templateUrl: './ea-product-sheet.component.html',
  styleUrls: ['./ea-product-sheet.component.scss'],
  standalone: false,
})
export class EaProductSheetComponent implements OnInit {
  userId: any;
  taxesData: any;
  nbChildren: number;

  loading: boolean;
  _ = _;
  getCurrentOpenFiscaSubject: Subject<any> = new Subject<any>();
  showBackground;
  backgroundClosing;
  alive = true;
  selectedProduct: Product;
  @ViewChild('customAction') customAction;
  @Output('onSimulate') onSimulate: EventEmitter<any> = new EventEmitter();
  @Output('onDiscover') onDiscover: EventEmitter<any> = new EventEmitter();
  @Input('showTitle') showTitle: boolean = true;
  @Input('product') set product(value) {
    this.selectedProduct = _.find(this.productsService.getProducts(), [
      'title',
      value,
    ]);
  }
  @Input() hasInfos: boolean = true;
  @Input() simple: boolean = false;
  showSimulation: boolean = true;

  constructor(
    private router: Router,
    private userDao: UserDao,
    protected productsService: ProductsService,
    private organizationSettingsDao: OrganizationSettingsDao,
  ) {}

  ngOnInit() {
    this.organizationSettingsDao
      .getOrganizationSettingsByKeyCheckIfClient(
        'ENABLED_SIMULATIONS_SOUSCRIPTIONS_ESPACE_CLIENT',
      )
      .subscribe(setting => {
        this.showSimulation = !!setting?.value;
      });
  }

  indexIsInRange(product: Product, index) {
    if (!product.riskRange[1] && index == product.riskRange[0]) return true;
    else if (index >= product.riskRange[0] && index <= product.riskRange[1])
      return true;
    else return false;
  }

  goToRoute(route, product?: Product) {
    // if (!product) {
    return this.router.navigate([route]);
    // }
    /* else {
      this.loaderService.startBackground();
      this.calculateTaxe(product).subscribe((queryParams) => {
        this.loaderService.stopBackground()
        this.router.navigate([route], { queryParams: queryParams })
      }) */

    // if (this.taxesData) this.getCurrentOpenFiscaSubject.next(this.taxesData);
    // }
  }

  calculateTaxe(product: Product): Observable<any> {
    return this.getCurrentOpenFiscaSubject.pipe(
      takeWhile(() => this.alive),
      map(taxesData => {
        let queryParams: any = {};
        if (taxesData && product.title) {
          if (product.title == 'SCPI')
            queryParams = {
              tmi: taxesData.tmargi,
              nbChildren: this.nbChildren || 0,
              annualIncome: taxesData.totalSalaryIncomes,
            };
          else if (product.title == 'PER')
            queryParams = {
              taxAmount: taxesData.taxAmount,
              tmi: taxesData.tmargi,
            };
          else queryParams = { taxAmount: taxesData.taxAmount };
        }
        return queryParams;
      }),
    );
  }

  ngOnDestroy() {
    this.alive = false;
  }
}
